import { INonprofitProfile } from '../../interfaces/nonprofitProfile/iNonprofitProfile';
import { IGeneralInfoOfNonprofit } from '../../interfaces/nonprofitProfile/iGeneralInfoOfNonprofit';
import { ICause } from '../../interfaces/iCause';
import { ILocation } from '../../interfaces/iLocation';
import { ISocialNetwork } from '../../interfaces/iSocialNetwork';
import { IInstitutionalSupport } from '../../interfaces/nonprofitProfile/iInstitutionalSupport';
import { ITextCard } from '../../interfaces/nonprofitProfile/iTextCard';
import { IOpportunities } from '../../interfaces/nonprofitProfile/iOpportunities';
import { IMemberOrganisationCard } from '../../interfaces/iMemberOrganisationCard';
import { IEventsOfNonprofit } from '../../interfaces/nonprofitProfile/iEventsOfNonprofit';
import { IMedia } from '../../interfaces/nonprofitProfile/iMedia';

export class NonprofitProfile implements INonprofitProfile {
	public causes: ICause[];
	public matchPercent: number;
	public media: IMedia;
	public isFan: boolean;
	public isAdmin: boolean;
	public locations: ILocation[];
	public generalInfo: IGeneralInfoOfNonprofit;
	public programs: ITextCard[];
	public history: ITextCard[];
	public socialMedias: ISocialNetwork[];
	public institutionalSupport: IInstitutionalSupport;
	public opportunities: IOpportunities;
	public ourExecutives: IMemberOrganisationCard[];
	public ourAssociateBoard: IMemberOrganisationCard[];
	public ourGoverningBoard: IMemberOrganisationCard[];
  public ourNationalGoverningBoard: IMemberOrganisationCard[];
  public ourAdvisoryBoard: IMemberOrganisationCard[];
	public ourStaff: IMemberOrganisationCard[];
	public fanMembers: IMemberOrganisationCard[];
	public ourEvents: IEventsOfNonprofit;
	public isHeadquarter: boolean;
	public orgKey: string;
	public isActive: boolean;
  public ratingEvaluator: object;

	constructor(nonprofitProfile: INonprofitProfile = {} as INonprofitProfile) {
    this.causes = nonprofitProfile.causes;
    this.matchPercent = nonprofitProfile.matchPercent;
    this.media = nonprofitProfile.media;
    this.isFan = !!nonprofitProfile.isFan;
    this.isAdmin = !!nonprofitProfile.isAdmin;
    this.locations = nonprofitProfile.locations;
    this.generalInfo = nonprofitProfile.generalInfo;
    this.programs = nonprofitProfile.programs;
    this.history = nonprofitProfile.history;
    this.socialMedias = nonprofitProfile.socialMedias;
    this.institutionalSupport = nonprofitProfile.institutionalSupport;
    this.opportunities = nonprofitProfile.opportunities;
    this.ourExecutives = !!nonprofitProfile.ourExecutives ? nonprofitProfile.ourExecutives : [];
    this.ourAssociateBoard = !!nonprofitProfile.ourAssociateBoard ? nonprofitProfile.ourAssociateBoard : [];
    this.ourGoverningBoard = !!nonprofitProfile.ourGoverningBoard ? nonprofitProfile.ourGoverningBoard : [];
    this.ourAdvisoryBoard= !!nonprofitProfile.ourAdvisoryBoard ? nonprofitProfile.ourAdvisoryBoard : [];
    this.ourNationalGoverningBoard = !!nonprofitProfile.ourNationalGoverningBoard ? nonprofitProfile.ourNationalGoverningBoard : [];
    this.ourStaff = !!nonprofitProfile.ourStaff ? nonprofitProfile.ourStaff : [];
    this.fanMembers = !!nonprofitProfile.fanMembers ? nonprofitProfile.fanMembers : [];
    this.ourEvents = nonprofitProfile.ourEvents;
    this.isHeadquarter = !!nonprofitProfile.isHeadquarter;
    this.orgKey = nonprofitProfile.orgKey;
    this.isActive = !!nonprofitProfile.isActive;
    this.ratingEvaluator = nonprofitProfile.ratingEvaluator;
  }
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/nonprofitProfile/nonprofitProfile.ts